export default __webpack_public_path__ + "static/media/041-inflatable boat.75bb0caf.svg";